export const detectOSNameFromUA = (ua: string): string => {
  if (ua.includes('Win')) return 'Windows OS';
  if (ua.includes('like Mac')) return 'iOS';
  if (ua.includes('Mac')) return 'Macintosh';
  if (ua.includes('Linux')) return 'Linux OS';
  if (ua.includes('Android')) return 'Android OS';

  return 'Unknown OS';
};
